import { createCircle } from "./utils";
//
// export const circle1 = createCircle({ x: 0, y: 0.00555, z: 0, radius1: 0.325, radius2: 0.18 });
//
// export const circle2 = createCircle({ x: 0, y: 0.0052, z: 0, radius1: 0.18, radius2: 0.22});

export const circle1 = createCircle({ x: 0, y: 0.855, z: 0, radius1: 0.325, radius2: 0.18 });


export const circle2 = createCircle({ x: 0, y: 0.809, z: 0, radius1: 0.195, radius2: 0.22});
